<template>
	<v-layout align-center justify-center>
		<v-flex xs3>
			<v-autocomplete
				browser-autocomplete="off"
				class="ma-2"
				:items="contestNames"
				v-model="searchFields.contestName"
				:label="isProject ? 'Nazwa naboru' : 'Nazwa konkursu'"
				aria-label="contest name"
				clearable
			></v-autocomplete>
		</v-flex>
		<v-flex xs2>
			<v-layout align-center justify-center>
				<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
				<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Pagination} from "@/utils/PaginationUtils";
  import {Filters} from "@/utils/Filters";
  import {PublicContest} from "@/api/generated/PublicContest";

	export default {
		name: "ContestOfferDepartmentFilters",

    mixins: [Filters],

		data() {
			return {
				searchFields: Pagination.initSearchedFields([
					"contestName",
				]),
				search: "",
				contestNames: []
			};
		},

		props: {
			value: {},
			isProject: {},
			evaluationType: {}
		},

		created () {
            PublicContest.getContestNames(this,this.$route.params.departmentId, response => {
				this.contestNames = response.map(x=>x.name);
			});
		},

    mounted () {
      this.searchFields = this.retrieveFilters(this.searchFields);
      this.buildNewSearch();
    },

		methods: {
			resetSearch() {
				Pagination.resetSearch(this.searchFields);
				this.search = "";
				this.buildNewSearch();
			},

			buildNewSearch() {
                this.searchFields.departmentId = this.$route.params.departmentId;
				this.search = Pagination.buildSearchCriteria(this.searchFields, false);
				this.$emit('input', this.search);
                this.$emit('getItemList');
			},
		}

	};
</script>

<style scoped>

</style>